function categories(api) {

    return {

      index: function (parent_id) {
        return api.request('categories', 'get', { 'main': parent_id });
    },
    save(id, data) {
        if (id == "new" || id == null) {
            return api.request('categories', 'post', null, data);
        }
        return api.request('categories/' + id, 'put', null, data);
    },
    remove(id) {
      if (id == "new" || id == null) {
          return []
      }
      return api.request('categories/' + id, 'delete', null, {});
  },
    update_order: function (list) {
        return api.request('categories/update_order', 'post', null, { 'array': list });
    }

    }


}
export default categories;
